// extracted by mini-css-extract-plugin
export default {"container":"KeySecurityOverview_container__X4O44","security":"KeySecurityOverview_security__hvtuq","title":"KeySecurityOverview_title__GIL-f"};